
let React = require("react");

let ApplicationContext = require("../../config/ApplicationContext.js");

class Thumbnail extends React.Component {

    constructor() {
        super();
      
        this.errorUrl =`${ApplicationContext.assetUrlPrefix}/assets/icons/icon-no-image.svg`;

        this.state = { src: this.errorUrl };

        this.onError = this.onError.bind(this);
    }

    componentWillMount(){
        let src = this.props.src || this.state.src;
        this.setState({ src });
    }

    shouldComponentUpdate(nextProps, nextState){
        return  nextState.src !== this.state.src
    }

    onError() {
        this.setState({ src: this.errorUrl });
    }

    render() {
        return <img 
            className={this.props.className} 
            alt={this.props.alt} 
            src={this.state.src} 
            onError={this.onError}
            />
    }

}

module.exports = Thumbnail;
 